import React from "react";
import { Drawer, Menu } from "antd";
import {
  AudioOutlined,
  FileTextOutlined,
  SettingOutlined,
} from "@ant-design/icons";
import { useTranslation } from "react-i18next";

import VoiceAgentTab from "./VoiceAgentTab";
import TemplatesTab from "./TemplatesTab";
import SettingsTab from "./SettingsTab";
import IntegrationsTab from "./IntegrationsTab";
import TeamTab from "./TeamTab";
import styles from "./style.module.scss";

const ConfigureChannelsDrawer = ({
  open,
  section,
  focusTest,
  focusCompliance,
  onClose,
  onSectionChange,
}) => {
  const { t } = useTranslation();

  return (
    <Drawer
      title={t("sonic.configure_channels")}
      placement="right"
      width={960}
      open={open}
      onClose={onClose}
      destroyOnClose={false}
      className={styles.configureDrawer}
    >
      <div className={styles.configureLayout}>
        <Menu
          mode="inline"
          selectedKeys={[section]}
          className={styles.configureMenu}
          onClick={({ key }) => onSectionChange(key)}
          items={[
            {
              key: "voice",
              icon: <AudioOutlined />,
              label: t("sonic.configure_section_voice"),
            },
            {
              key: "whatsapp",
              icon: <FileTextOutlined />,
              label: t("sonic.configure_section_whatsapp"),
            },
            {
              key: "organization",
              icon: <SettingOutlined />,
              label: t("sonic.configure_section_organization"),
            },
          ]}
        />
        <div className={styles.configureContent}>
          {section === "voice" && (
            <VoiceAgentTab active={open} focusTest={focusTest} embedded />
          )}
          {section === "whatsapp" && (
            <TemplatesTab active={open} focusTest={focusTest} />
          )}
          {section === "organization" && (
            <>
              <SettingsTab
                active={open}
                focusCompliance={focusCompliance}
              />
              <div className={styles.configureSubSection}>
                <IntegrationsTab active={open} />
              </div>
              <div className={styles.configureSubSection}>
                <TeamTab active={open} />
              </div>
            </>
          )}
        </div>
      </div>
    </Drawer>
  );
};

export default ConfigureChannelsDrawer;
